/*
	Generated on 10/05/2025 by UI Generator PRICES-IDE
	https://amanah.cs.ui.ac.id/research/ifml-regen
	version 3.10.0
*/
import React, { useEffect, useState, useContext} from 'react'
import { Button, Spinner } from "@/commons/components"
import * as Layouts from '@/commons/layouts';
import { Link } from "react-router";
import { useParams } from "@/commons/hooks/useParams"
import { HeaderContext } from "@/commons/components"
import { useNavigate } from "react-router";
import { useAuth } from '@/commons/auth';
import FormFilterSemester from '../components/FormFilterSemester'

import getSemesterList from '../services/getSemesterList'
import PenggunaanTable from "../components/PenggunaanTable";

import getPenggunaanRuanganDataList from '../services/getPenggunaanRuanganDataList'
import getRuanganSelectionField from '../services/getRuanganSelectionField'
const DaftarPenggunaanRuanganPage = props => {
const { checkPermission } = useAuth();

	const [isLoading, setIsLoading] = useState({
	filterSemester: false,
	daftarPenggunaanRuangan: false,

	});
	const { setTitle } = useContext(HeaderContext);

const [semesterList, setSemesterList] = useState()

useEffect(() => {
    const fetch = async () => {
	  setIsLoading(prev => ({...prev, filterSemester: true}))
		const { data: semesterListResponse } = await getSemesterList({  })

	    setSemesterList(semesterListResponse.data)


	    setIsLoading(prev => ({...prev, filterSemester: false}))
    }
	fetch()
  }, [])
const [penggunaanRuanganDataList, setPenggunaanRuanganDataList] = useState()
	
	const [ruanganSelectionField, setRuanganSelectionField] = useState()
	
	
	
	const [daftarPenggunaanRuanganParams, setDaftarPenggunaanRuanganParams] = useState()
	useEffect(() => {
		if (!daftarPenggunaanRuanganParams) return

		const fetchData = async () => {
			try {
				setIsLoading(prev => ({...prev, daftarPenggunaanRuangan: true}))
				const { data: penggunaanRuanganDataList } = await getPenggunaanRuanganDataList(daftarPenggunaanRuanganParams)
				const { data: ruanganSelectionField } = await getRuanganSelectionField(daftarPenggunaanRuanganParams)
				setPenggunaanRuanganDataList(penggunaanRuanganDataList.data)
				setRuanganSelectionField(ruanganSelectionField.data)
			} finally {
				setIsLoading(prev => ({...prev, daftarPenggunaanRuangan: false}))
			}
		}
		fetchData()
  	}, [daftarPenggunaanRuanganParams])

	
	useEffect(() => {
		setTitle("Daftar Penggunaan Ruangan Page")
	}, []);
return (
	<Layouts.ViewContainerLayout
		buttons={
			<>
			<></>
			</>
		}
	>
<Layouts.FormContainerLayout
		singularName={"Semester"}
		isLoading={isLoading.filterSemester}
	>
		{semesterList ? 
		(<>
		 <FormFilterSemester
			{...{ 
				semesterList
				,  setDaftarPenggunaanRuanganParams
				}}
		 /> 
		</>)  : (<></>)}
	</Layouts.FormContainerLayout>
{ daftarPenggunaanRuanganParams && ( 
<Layouts.ListContainerTableLayout
	title={"Daftar Penggunaan Ruangan"}
	singularName={"Penggunaan"}
	items={[penggunaanRuanganDataList]}
	isLoading={isLoading.daftarPenggunaanRuangan}
>
	<PenggunaanTable
		penggunaanRuanganDataList={penggunaanRuanganDataList}
		ruanganSelectionField={ruanganSelectionField}
		
	/>
</Layouts.ListContainerTableLayout>
)}

	</Layouts.ViewContainerLayout>
  )
}
export default DaftarPenggunaanRuanganPage

